function plan_Reducer(state = [], action) {
    switch (action.type) {
        case 'PLAN/SET':            
            return action.plan;
        case 'PLAN/CLEAR':
            return null;
        default:
            return state;
    }
}

export default plan_Reducer;
